import Lightning from '@lightningjs/core';
import { FatalErrorScreenTSpec } from './FatalErrorScreen.tSpec';
import { FatalErrorScreenTypeConf } from './FatalErrorScreen.typeConf';
import { Button } from '../components/shared/Button';
import { SysCalls } from '../syscalls/Syscalls';
import { Theme } from '../config/theme';
import { Backend } from '../api/Backend';
import { ErrorTranslationKeys, GeneralTranslationKeys } from '../api/models/TranslationKeys';
import { BootstrapErrors } from '../api/Errors';

interface ErrorParams {
  backend: Backend;
  error?: any;
}

export class FatalErrorScreen
  extends Lightning.Component<FatalErrorScreenTSpec, FatalErrorScreenTypeConf>
  implements Lightning.Component.ImplementTemplateSpec<FatalErrorScreenTSpec>
{
  static override _template(): Lightning.Component.Template<FatalErrorScreenTSpec> {
    return {
      x: 0,
      y: 0,
      w: (w: number) => w,
      h: (h: number) => h,
      rect: true,
      color: Theme.Colors.Black,

      Message: {
        mountX: 0.5,
        mountY: 1,
        x: w => w / 2,
        y: h => h / 2,
        text: {
          wordWrapWidth: 1920 / 2,
          textAlign: 'center',
        },
      },

      Button: {
        type: Button,
        mount: 0.5,
        x: (w: number) => w / 2,
        y: (h: number) => h / 2 + 75,
        signals: {
          onActivate: '_handleEnter',
        },
      },
    };
  }

  private message = this.getByRef('Message')!;
  private exitButton = this.getByRef('Button')!;

  override _onChanged() {
    const params = this.params as ErrorParams;
    if (params.error && params.error.code) {
      const errorCode = params.error.code.toLowerCase();
      let errorMessage = params.backend.translations.forKey(ErrorTranslationKeys.error_general);
      if (errorCode === BootstrapErrors.API_UNSUPPORTED_APP_VERSION) {
        errorMessage =
          params.error.message || params.backend.translations.forKey(ErrorTranslationKeys.API_UNSUPPORTED_APP_VERSION);
      } else if (errorCode === BootstrapErrors.API_UNSUPPORTED_OS_VERSION) {
        errorMessage =
          params.error.message || params.backend.translations.forKey(ErrorTranslationKeys.API_UNSUPPORTED_OS_VERSION);
      }

      this.message.patch({
        text: {
          text: errorMessage,
        },
      });
    } else {
      this.message.patch({
        text: {
          text: params.backend.translations.forKey(ErrorTranslationKeys.error_general),
        },
      });
    }

    this.exitButton.patch({
      label: params.backend.translations.forKey(GeneralTranslationKeys.app_btn_close),
    });
  }

  override _getFocused() {
    return this.getByRef('Button')!;
  }

  override _handleEnter() {
    SysCalls.exitApp(this);
  }

  override _handleBack() {
    SysCalls.exitApp(this);
  }
}
